module.exports = __webpack_public_path__ + "static/media/serviceCenterImg01.3299a4c8.png";